import { PREVIEW_PRODUCTS } from "./catalog";
import { variantForProduct } from "./variants";
export const MAX_QUANTITY = 99;
export const lineKey = (id, flavor) => `${id}__${flavor || "default"}`;
export function cartProduct(id) {
  const product = PREVIEW_PRODUCTS.find(p => p.id === id);
  if (!product || product.coming_soon || !Number.isFinite(product.price)) return null;
  const variant = variantForProduct(product);
  return { id: product.id, name: product.name, price: product.price,
    flavor: variant.flavour, image_url: variant.artwork, accent: product.accent };
}
export function quantityValue(value) {
  const n = Number(value);
  return Number.isFinite(n) ? Math.min(MAX_QUANTITY, Math.max(0, Math.floor(n))) : 0;
}
export function normalizeCart(saved) {
  if (!Array.isArray(saved)) return [];
  const result = [];
  saved.forEach(item => {
    const product = cartProduct(item?.id);
    const quantity = quantityValue(item?.quantity);
    if (!product || !quantity) return;
    const existing = result.find(i => i.id === product.id);
    if (existing) existing.quantity = quantityValue(existing.quantity + quantity);
    else result.push({ ...product, quantity });
  });
  return result;
}
export function cartTotals(items, purchaseType) {
  const subtotalPence = items.reduce((sum, item) => sum + Math.round(item.price * 100) * item.quantity, 0);
  const discountPence = purchaseType === "subscribe" ? Math.round(subtotalPence * 0.15) : 0;
  return { subtotal: subtotalPence / 100, discount: discountPence / 100, shipping: 0,
    total: (subtotalPence - discountPence) / 100 };
}

